import React from 'react';
import PropTypes from 'prop-types';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import DesktopColumnsMobileStack from 'components/consumer/DesktopColumnsMobileStack/DesktopColumnsMobileStack';

const IconTextSet = ({
  config: { heading, contentColumn1, contentColumn2, contentColumn3 },
}) => {
  const HeaderTag = heading.tagName || 'div';
  return (
    <FixedWidthContainer>
      {heading && heading.content && (
        <HeaderTag className="text-3xl font-bold text-gray mb-8 text-center w-full before:[border-top:2px_solid_#107c8c] before:box-border before:[content:''] before:block before:h-0 before:mt-0 before:mx-0 before:mb-5 before:w-[30px] before:md:mt-0 before:md:mx-auto before:md:mb-10 before:md:w-10">
          {heading.content}
        </HeaderTag>
      )}

      <DesktopColumnsMobileStack>
        {[contentColumn1, contentColumn2, contentColumn3].map(
          ({ imageProps, heading: columnHeading, subText }) => {
            const HeaderTag2 = columnHeading?.tagName || 'div';
            return (
              <div
                className="content-center flex flex-col justify-center p-6 text-center"
                key={columnHeading?.content}
              >
                <div className="flex justify-center">
                  <img
                    src={imageProps.src}
                    alt="SVG Icon"
                    className="half-image !w-[70px]"
                  />
                </div>

                <HeaderTag2 className="text-xl font-bold text-gray mt-4 mx-0 mb-1">
                  {columnHeading?.content}
                </HeaderTag2>

                <div
                  className="text-base text-gray mt-2 mx-auto mb-[1.2rem] max-w-[400px]"
                  dangerouslySetInnerHTML={{ __html: subText.content }}
                />
              </div>
            );
          }
        )}
      </DesktopColumnsMobileStack>
    </FixedWidthContainer>
  );
};

IconTextSet.propTypes = {
  config: PropTypes.shape({
    heading: PropTypes.object,
    contentColumn1: PropTypes.object,
    contentColumn2: PropTypes.object,
    contentColumn3: PropTypes.object,
  }),
};

export default IconTextSet;
